import { useAppShortcut } from '@/features/shortcuts';
import { useHashRoute } from '@/hooks/useHashRoute';
import { AppCapability, isCapable } from '@/utils/capabilities';

export function useRegisterGoToSettingsHotkey() {
  const { setHash } = useHashRoute();

  useAppShortcut(
    'app.openSettings',
    () => {
      if (!isCapable(AppCapability.HotKeys)) return;
      setHash('settings/General');
    },
    {
      preventDefault: true,
      enableOnContentEditable: true,
      enableOnFormTags: true,
    }
  );
}
